import React, { forwardRef } from 'react'
import emphasizeAmpersand from 'src/helpers/emphasizeAmpersand'

interface IPageTitleProps {
  firstPart: string
  secondPart: string
  thirdPart?: string
  secondPartClassName?: string
  fontClassName?: string
  className?: string
  theme?: 'light' | 'dark'
}

const renderPart = (text?: string, className?: string, isLast = false) => {
  if (!text) return null
  const lines = text.split(/\n|<br\s*\/?>/i)
  return lines.map((line, i) => (
    <span key={i} className={`inline md:block ${className || ''}`}>
      {emphasizeAmpersand(line, 1.1)}{!isLast ? ' ' : ''}
    </span>
  ))
}

const H1 = forwardRef<HTMLHeadingElement, IPageTitleProps>(
  ({ firstPart, secondPart, thirdPart, className, theme }, ref) => {
    const textColor = 'text-black dark:text-white'
    const hasThreeParts = Boolean(thirdPart && thirdPart.trim())
    const secondPartColor = hasThreeParts ? textColor : 'text-red'

    return (
      <h1
        ref={ref}
        className={`font-palanquinDark text-display-extra-large md:text-heading-h5 lg:text-heading-h4 xl:text-heading-h1 font-bold ${className}`}
      >
        {renderPart(firstPart, textColor, false)}
        {renderPart(secondPart, secondPartColor, !hasThreeParts)}
        {thirdPart && renderPart(thirdPart, 'text-red', true)}
      </h1>
    )
  }
)

H1.defaultProps = {
  className: '',
  theme: 'light',
}

export default H1
